/// <amd-module name="TFS/TeamProfilePanelIconButton/TeamProfilePanelIconButton" />
import * as React from "react";
import * as Resources from "TFS/TeamProfilePanelIconButton/Resources";
import { IVssLayoutManager, usePageContext, WrappedComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

export interface ITeamProfilePanelIconButton {
    className?: string;
    renderLoadingPanel?: (onDismiss: () => void) => JSX.Element;
    teamId: string;
    teamName: string;
}

export function TeamProfilePanelIconButton(props: ITeamProfilePanelIconButton): JSX.Element {
    const { className, renderLoadingPanel, teamId, teamName } = props;
    const pageContext = usePageContext();

    const onTeamPanelClick = (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => {
        event.preventDefault();
        const layoutService = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutService.renderCallout((onDismiss) => {
            return (
                <WrappedComponent
                    dependencies={["ms.vss-tfs-web.team-profile-panel-content"]}
                    loadingComponent={renderLoadingPanel ? () => renderLoadingPanel(onDismiss) : undefined}
                    wrappedProps={{
                        teamId: teamId,
                        teamName: teamName,
                        onDismiss: onDismiss
                    }}
                    wrappedType="ms.vss-tfs-web.team-profile-panel-component"
                />
            );
        });
    };

    return (
        <Button
            ariaLabel={Resources.ShowTeamProfile}
            className={className}
            iconProps={{ iconName: "People" }}
            onClick={(event) => onTeamPanelClick(event)}
            subtle={true}
            tooltipProps={{ showOnFocus: true, text: Resources.ShowTeamProfile }}
        />
    );
}
